import { GetFacturationExclusionRulesResponse } from "@/app/api/facturation-exclusion-rules/route";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";
import { getFacturationExclusionRulesRequestSchema } from "@/lib/schemas/facturation-exclusion-rules";

const FACTURATION_EXCLUSION_RULES_ENDPOINT = "/api/facturation-exclusion-rules";

export const invalidateFacturationExclusionRulesQuery = createInvalidateQuery(
  FACTURATION_EXCLUSION_RULES_ENDPOINT,
);

export const useFacturationExclusionRulesQuery =
  createQueryHook<GetFacturationExclusionRulesResponse>(
    FACTURATION_EXCLUSION_RULES_ENDPOINT,
    getFacturationExclusionRulesRequestSchema,
  );
